import { useCallback } from "react";
import { useRuntimeLocale } from "@/shared/I18nRuntimeProvider";
import { normalizeUiLocale } from "@/lib/i18n/uiLocale";

export const useLocale = () => {
  const { locale, changeLanguage: changeRuntimeLanguage } = useRuntimeLocale();

  const getCurrentLocale = (): string => locale;

  const changeLanguage = useCallback(
    (nextLocale: string) => {
      const normalized = normalizeUiLocale(nextLocale);
      if (!normalized) return;

      // Fire-and-forget: hook API is sync, provider loads dictionaries async.
      void changeRuntimeLanguage(normalized);
    },
    [changeRuntimeLanguage]
  );

  return {
    currentLocale: locale,
    changeLanguage,
    getCurrentLocale,
  };
};
